import * as React from "react"
import './styles.scss'

export default class Spinner extends React.Component {
    render() {
        return <div id="cover-spin" style={{ display: 'block' }}></div>
    }
}



// WEBPACK FOOTER //
// ./src/component/scenarii/detail/spinner.tsx